// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  zoneId: __t.string().name("zone_id"),
  zoneType: __t.string().name("zone_type"),
  skillId: __t.string().name("skill_id"),
  sourceEntityId: __t.string().name("source_entity_id"),
  instanceId: __t.string().name("instance_id"),
  mapId: __t.string().name("map_id"),
  centerX: __t.i32().name("center_x"),
  centerY: __t.i32().name("center_y"),
  radius: __t.i32(),
  expiresAtTick: __t.i64().name("expires_at_tick"),
});
